module.exports = __webpack_public_path__ + "static/media/mango.c586a6ab.png";